import { FiPlus } from 'react-icons/fi';
import { Badge } from '@mui/material';
import {
  Card,
  CardBody,
  CardCategory,
  CardDescription,
  CardFooter,
  CardImage,
  CardName,
  CardSku,
  OutlineAddButton,
} from './catalogStyles';

export const ProductCard = ({
  product,
  added,
  selectedQuantity,
  onOpen,
  onAdd,
}) => (
  <Card $selected={selectedQuantity > 0} onClick={() => onOpen(product)}>
    {selectedQuantity > 0 && (
      <Badge
        badgeContent={selectedQuantity}
        color="success"
        max={99}
        aria-label={`${selectedQuantity} unidade${
          selectedQuantity === 1 ? '' : 's'
        } selecionada${selectedQuantity === 1 ? '' : 's'}`}
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          '& .MuiBadge-badge': {
            fontWeight: 700,
            minWidth: 22,
            height: 22,
          },
        }}
      >
        <span />
      </Badge>
    )}
    <CardImage>
      <img src={product.images[0]} alt={product.name} />
    </CardImage>
    <CardBody>
      <CardCategory title={product.category}>{product.category}</CardCategory>
      <CardName>{product.name}</CardName>
      <CardSku>SKU {product.sku}</CardSku>
      <CardDescription>
        {product.description || 'Descrição não disponível para este produto.'}
      </CardDescription>
      <CardFooter>
        <OutlineAddButton
          $added={added}
          onClick={(event) => {
            event.stopPropagation();
            onAdd(product, 1);
          }}
        >
          <>
            <FiPlus /> Adicionar
          </>
        </OutlineAddButton>
      </CardFooter>
    </CardBody>
  </Card>
);
